import {
  AuthApi,
  AuthV1LoginCreateRequest,
  LoginPostResponse,
  LoginGetSuccess,
  PhoneConfirmRequestGetSuccess,
  RepeatPhoneConfirmRequestGetSuccess,
  AuthV1LoginListRequest,
  AuthV1ConfirmEmailRequest,
  AuthV1PhoneConfirmRequest,
  AuthV1RepeatPhoneConfirmRequest,
  AuthV1SmsLoginRequest,
  SmsLoginResponse,
  Profile,
} from '@/requests/mainApi';
import { IResponse, requestMachine } from '@/requests/requestMachine';

export default {
  getAuthCode(variables: AuthV1LoginListRequest): Promise<IResponse<LoginGetSuccess>> {
    return requestMachine<LoginGetSuccess, AuthV1LoginListRequest>(AuthApi, 'authV1LoginList', false, variables);
  },

  getPhoneConfirmRequest(variables: AuthV1PhoneConfirmRequest): Promise<IResponse<PhoneConfirmRequestGetSuccess>> {
    return requestMachine<PhoneConfirmRequestGetSuccess, AuthV1PhoneConfirmRequest>(AuthApi, 'authV1PhoneConfirm', false, variables);
  },

  repeatPhoneConfirm(variables: AuthV1RepeatPhoneConfirmRequest): Promise<IResponse<RepeatPhoneConfirmRequestGetSuccess>> {
    return requestMachine<RepeatPhoneConfirmRequestGetSuccess, AuthV1RepeatPhoneConfirmRequest>(AuthApi, 'authV1RepeatPhoneConfirm', false, variables);
  },

  signIn(variables: AuthV1LoginCreateRequest): Promise<IResponse<LoginPostResponse>> {
    return requestMachine<LoginPostResponse, AuthV1LoginCreateRequest>(AuthApi, 'authV1LoginCreate', false, variables);
  },

  smsSignIn(variables: AuthV1SmsLoginRequest): Promise<IResponse<SmsLoginResponse>> {
    return requestMachine<SmsLoginResponse, AuthV1SmsLoginRequest>(AuthApi, 'authV1SmsLoginCreate', false, variables);
  },

  getBasisWidgetToken(): Promise<IResponse<{ url: string }>> {
    return requestMachine<{ url: string }, null>(AuthApi, 'authV1BasisWidget', true);
  },

  confirmEmail(variables: AuthV1ConfirmEmailRequest): Promise<IResponse<Profile>> {
    return requestMachine<Profile, AuthV1ConfirmEmailRequest>(AuthApi, 'authV1ConfirmEmail', true, variables);
  },
};
